// extracted by mini-css-extract-plugin
export default {"search-banner--width":"search-banner--width_p1fi5M0w"};